/* Car Key Shop vehicle-fitment parser.
   Reads each product's description and pulls out "Model YYYY - YYYY" style lines. */
var CKS = (function () {
  var THIS_YEAR = new Date().getFullYear();

  // canonical make -> aliases (lower case). Order matters: longer aliases first when matching.
  var MAKES = {
    'Abarth': ['abarth'],
    'Alfa Romeo': ['alfa romeo', 'alfa-romeo', 'alfa'],
    'Audi': ['audi'],
    'BMW': ['bmw'],
    'Chrysler': ['chrysler'],
    'Citroën': ['citroen', 'citroën'],
    'Dacia': ['dacia'],
    'DS': ['ds'],
    'Fiat': ['fiat'],
    'Ford': ['ford'],
    'Honda': ['honda'],
    'Hyundai': ['hyundai'],
    'Iveco': ['iveco'],
    'Jaguar': ['jaguar'],
    'Jeep': ['jeep'],
    'Kia': ['kia'],
    'Lancia': ['lancia'],
    'Land Rover': ['land rover', 'range rover', 'landrover'],
    'LDV / Maxus': ['ldv', 'maxus'],
    'Lexus': ['lexus'],
    'Maserati': ['maserati'],
    'Mazda': ['mazda'],
    'Mercedes-Benz': ['mercedes-benz', 'mercedes benz', 'mercedes'],
    'Mini': ['bmw mini', 'mini'],
    'Mitsubishi': ['mitsubishi'],
    'Nissan': ['nissan'],
    'Peugeot': ['peugeot'],
    'Porsche': ['porsche'],
    'Renault': ['renault'],
    'Seat': ['seat'],
    'Skoda': ['skoda', 'škoda'],
    'Smart': ['smart'],
    'Bentley': ['bentley'],
    'Chevrolet': ['chevrolet'],
    'Dodge': ['dodge'],
    'Lamborghini': ['lamborghini'],
    'MG / Rover': ['mg rover', 'mg', 'rover'],
    'Pontiac': ['pontiac'],
    'Proton': ['proton'],
    'Subaru': ['subaru'],
    'Suzuki': ['suzuki'],
    'Toyota': ['toyota'],
    'Vauxhall / Opel': ['vauxhall / opel', 'vauxhall/opel', 'vauxhall', 'opel'],
    'Volkswagen': ['volkswagen', 'vw'],
    'Volvo': ['volvo']
  };
  // "Range Rover Sport" is a model name, so keep "Range Rover" in the model when that alias matched
  var KEEP_ALIAS_IN_MODEL = { 'range rover': 1 };
  // aliases that are also ordinary words: only trust them at the start of a fitment line, never in titles/tags
  var LINE_ONLY = { 'smart': 1, 'mini': 0, 'rover': 1, 'mg': 1, 'alfa': 1 };
  // per-make model renames (shorthand used in some descriptions)
  var MODEL_FIX = {
    'Land Rover': { 'sport': 'Range Rover Sport', 'vogue': 'Range Rover', 'evoque': 'Range Rover Evoque', 'velar': 'Range Rover Velar', 'range rover vogue': 'Range Rover' },
    'Vauxhall / Opel': { 'cascade': 'Cascada' },
    'Renault': { 'val satis': 'Vel Satis' }
  };
  var BMW_CHASSIS = { e81:'1 Series', e82:'1 Series', e87:'1 Series', e88:'1 Series', e90:'3 Series', e91:'3 Series', e92:'3 Series', e93:'3 Series',
    e60:'5 Series', e61:'5 Series', e63:'6 Series', e64:'6 Series', e65:'7 Series', e66:'7 Series', e83:'X3', e84:'X1', e70:'X5', e71:'X6', e85:'Z4', e86:'Z4', e89:'Z4' };

  var ALIASES = [];
  Object.keys(MAKES).forEach(function (m) {
    MAKES[m].forEach(function (a) { ALIASES.push([a, m]); });
  });
  ALIASES.sort(function (a, b) { return b[0].length - a[0].length; });

  function esc(s) { return s.replace(/[.*+?^${}()|[\]\\\/]/g, '\\$&'); }
  function norm(s) {
    return s.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  }

  // find make aliases at the start of a string
  function leadingMake(text) {
    var t = norm(text);
    for (var i = 0; i < ALIASES.length; i++) {
      var a = norm(ALIASES[i][0]);
      if (t === a || t.indexOf(a + ' ') === 0 || t.indexOf(a + '/') === 0) {
        return { make: ALIASES[i][1], alias: ALIASES[i][0], rest: text.slice(a.length).replace(/^[\s\/,:-]+/, '') };
      }
    }
    return null;
  }

  // all makes mentioned anywhere in a string (for titles / tags)
  function makesIn(text) {
    var t = ' ' + norm(text).replace(/[^a-z0-9]+/g, ' ') + ' ', found = [];
    ALIASES.forEach(function (p) {
      if (LINE_ONLY[p[0]]) return;
      var a = ' ' + norm(p[0]).replace(/[^a-z0-9]+/g, ' ') + ' ';
      if (t.indexOf(a) > -1 && found.indexOf(p[1]) < 0) found.push(p[1]);
    });
    return found;
  }

  function decode(s) {
    return s.replace(/&nbsp;/g, ' ').replace(/&amp;/g, '&').replace(/&gt;/g, '>').replace(/&lt;/g, '<')
      .replace(/&quot;/g, '"').replace(/&#39;|&rsquo;|&lsquo;/g, "'").replace(/&ndash;|&mdash;/g, '-')
      .replace(/&#(\d+);/g, function (_, n) { return String.fromCharCode(+n); });
  }

  function lines(html) {
    var t = (html || '')
      .replace(/<\/(li|p|h\d|div|tr|section|ul|ol)>|<br\s*\/?>/gi, '\n')
      .replace(/<\/(td|th|span)>/gi, ' ')
      .replace(/<[^>]+>/g, '');
    return decode(t).split('\n').map(function (l) { return l.replace(/\s+/g, ' ').trim(); })
      .filter(Boolean);
  }

  var Y = '((?:19|20)\\d\\d)';
  var MON = '(?:\\d{1,2}\\/|\\b(?:jan(?:uary)?|feb(?:ruary)?|mar(?:ch)?|apr(?:il)?|may|june?|july?|aug(?:ust)?|sept?(?:ember)?|oct(?:ober)?|nov(?:ember)?|dec(?:ember)?)\\.?\\s+)?';
  var RANGE = new RegExp(
    '\\(?\\s*' + MON + Y + '\\s*' +
    '(?:(?:-|–|—|to|until)\\s*' + MON + '(' + '(?:19|20)\\d\\d|present|onwards?|current|now|on|>|\\+' + ')|(>|\\+|onwards?|on\\b))?' +
    '\\s*\\)?', 'i');

  function toYear(v) {
    if (!v) return null;
    if (/^(19|20)\d\d$/.test(v)) return +v;
    return THIS_YEAR; // present / onwards / >
  }

  function cleanModel(m) {
    return m.replace(/\s*[-–—:,(]+\s*$/, '').replace(/^[-–—•*:\s]+/, '')
      .replace(/\b(models?|from|between|years?)\s*$/i, '').trim();
  }

  function titleCase(s) {
    // "Bmw 1 Series" -> keep model case but fix all-lower words like "range rover sport"
    return s.replace(/\b([a-z])([a-z]{2,})\b/g, function (w, a, b) {
      return /^(and|or|of|with)$/.test(w) ? w : a.toUpperCase() + b;
    });
  }

  function fixModel(make, model) {
    var k = norm(model);
    if (MODEL_FIX[make] && MODEL_FIX[make][k]) return MODEL_FIX[make][k];
    if (make === 'BMW') {
      var ch = k.match(/^(e\d\d)\b/);
      if (ch && BMW_CHASSIS[ch[1]]) return BMW_CHASSIS[ch[1]];
      model = model.replace(/^(\d Series|[XZ]\d)\s+[EFG]\d\d.*$/i, '$1');
    }
    if (make === 'Mercedes-Benz') model = model.replace(/^([A-Z]{1,3})[ -]Class$/i, function (_, c) { return c.toUpperCase() + '-Class'; });
    return model.replace(/\s*\/\s*/g, ' / ').replace(/\s+&\s+/g, ' & ');
  }

  // "Transit / Tourneo Custom" -> ["Transit Custom", "Tourneo Custom"]; "Almera & Almera Tino" -> both
  function splitModels(model) {
    if (model === '*') return ['*'];
    var parts = model.split(/\s*\/\s*/).filter(Boolean);
    if (parts.length > 1) {
      var last = parts[parts.length - 1].split(' ');
      if (last.length > 1 && parts.slice(0, -1).every(function (p) { return p.indexOf(' ') < 0 && !/^\d/.test(p); })) {
        var suffix = last.slice(1).join(' ');
        parts = parts.slice(0, -1).map(function (p) { return p + ' ' + suffix; }).concat(parts[parts.length - 1]);
      }
      // "Discovery/Sport" style fragments that are just a trailing word stay as they are
      return parts;
    }
    var amp = model.split(/\s+&\s+/);
    if (amp.length === 2 && amp[1].split(' ')[0] === amp[0].split(' ')[0]) return amp;
    return [model];
  }

  // generation markers collapse into the base model: "Astra J" -> "Astra", "Clio III" -> "Clio", "Micra K12" -> "Micra"
  var GEN = /^(?:i{1,3}|iv|v|vi|[a-hj-k]|mk\s?\d+|mark\s?\d+|[a-z]\d{1,3}[a-z]?)$/i;
  function baseModel(label) {
    if (label === '*') return '*';
    var w = label.split(' ');
    if (w.length === 2 && /^[A-Za-z][a-z]{2,}$/.test(w[0]) && GEN.test(w[1])) return w[0];
    return label;
  }

  // Parse one product -> [{make, model, from, to}]
  function parseProduct(p, modelIndex) {
    var ctxMakes = makesIn(p.title + ' ' + (p.vendor || '') + ' ' + (p.tags || []).join(' , '));
    var titleMakes = makesIn(p.title);
    var out = [], seen = {};

    lines(p.body_html).forEach(function (line) {
      if (line.length > 80) return;             // prose sentences
      if (/genuine part|part number|oem|frequency|battery|mhz/i.test(line)) return;
      var m = line.match(RANGE);
      if (!m) return;
      var from = +m[1], to = toYear(m[2] || m[3]);
      if (to === null) to = from;
      if (from < 1980 || from > THIS_YEAR + 1 || to < from) return;
      var before = cleanModel(line.slice(0, m.index).replace(/^(vehicle compatibility|vehicle|models?)\s*:?\s*/i, ''));
      var note = '';
      var nm = before.match(/\s*(\((?:with|without|pre|post|not)[^)]*\)?|\b(?:with|without)\s+.*)$/i);
      if (nm) { note = nm[1].replace(/^\(|\)$/g, ''); before = before.slice(0, nm.index).trim(); }
      var after = line.slice(m.index + m[0].length).match(/^\s*\(([^)]+)\)/);
      if (after) note = note || after[1];
      if (/^various\b/i.test(before)) return;
      if (!before || /^(suitable|compatible|fits|designed)/i.test(before)) return;
      // skip things that are clearly not vehicles (part numbers etc.)
      if (/^\d{6,}/.test(before)) return;

      var make = null, model = before, lm = leadingMake(before);
      if (lm) {
        make = lm.make;
        model = KEEP_ALIAS_IN_MODEL[lm.alias] ? before : lm.rest;
        // "Seat Seat Leon", "Vauxhall Opel Combo", "Vauxhall / Opel Vauxhall/Opel Combo"
        for (var g = 0, again; g < 3 && (again = leadingMake(model)) && again.make === make && !KEEP_ALIAS_IN_MODEL[again.alias]; g++) model = again.rest;
      } else if (modelIndex && modelIndex[norm(before)] && ctxMakes.indexOf(modelIndex[norm(before)]) > -1) {
        make = modelIndex[norm(before)];
      } else if (titleMakes.length) {
        make = titleMakes[0];
      } else if (ctxMakes.length) {
        make = ctxMakes[0];
      }
      if (!make) return;
      model = fixModel(make, titleCase(cleanModel(model)));
      if (!model) return;
      if (/^all( models)?$/i.test(model)) model = '*';
      splitModels(model).forEach(function (label) {
        label = fixModel(make, label);
        var base = baseModel(label);
        var key = make + '|' + norm(label) + '|' + from + '|' + to;
        if (seen[key]) return;
        seen[key] = 1;
        out.push({ make: make, model: base, label: label, from: from, to: to, note: note });
      });
    });
    return out;
  }

  // Build full index from an array of {title, vendor, tags, body_html}
  // returns { fits: [[productIdx, make, modelKey, from, to, note]], makes: {make: {modelKey: {name, from, to}}} }
  function build(products) {
    // pass 1: learn model -> make from lines that name the make explicitly
    var modelIndex = {};
    products.forEach(function (p) {
      parseProduct(p, null).forEach(function (f) {
        var k = norm(f.model);
        if (f.model !== '*' && !modelIndex[k]) modelIndex[k] = f.make;
      });
    });
    var fits = [], makes = {}, votes = {};
    products.forEach(function (p, i) {
      parseProduct(p, modelIndex).forEach(function (f) {
        var mk = f.model === '*' ? '*' : modelKey(f.model);
        fits.push([i, f.make, mk, f.from, f.to, f.label + (f.note ? ' (' + f.note + ')' : '')]);
        makes[f.make] = makes[f.make] || {};
        if (mk === '*') return;
        var r = makes[f.make][mk];
        if (!r) r = makes[f.make][mk] = { name: f.model, from: f.from, to: f.to };
        r.from = Math.min(r.from, f.from); r.to = Math.max(r.to, f.to);
        // most common spelling wins ("EcoSport" vs "Ecosport")
        var vk = f.make + '|' + mk + '|' + f.model;
        votes[vk] = (votes[vk] || 0) + 1;
        if (votes[vk] > (votes[f.make + '|' + mk + '|' + r.name] || 0)) r.name = f.model;
      });
    });
    return { fits: fits, makes: makes };
  }

  // Same as build(), but works through the catalogue in small time slices so the page never
  // freezes (one long parse was showing up as Total Blocking Time in Lighthouse).
  function buildAsync(products, done) {
    var modelIndex = {}, fits = [], makes = {}, votes = {};
    function sliced(fn, next) {
      var i = 0;
      (function run() {
        var end = Date.now() + 8;
        while (i < products.length && Date.now() < end) { fn(products[i], i); i++; }
        if (i < products.length) setTimeout(run, 0); else next();
      })();
    }
    sliced(function (p) {
      parseProduct(p, null).forEach(function (f) {
        var k = norm(f.model);
        if (f.model !== '*' && !modelIndex[k]) modelIndex[k] = f.make;
      });
    }, function () {
      sliced(function (p, i) {
        parseProduct(p, modelIndex).forEach(function (f) {
          var mk = f.model === '*' ? '*' : modelKey(f.model);
          fits.push([i, f.make, mk, f.from, f.to, f.label + (f.note ? ' (' + f.note + ')' : '')]);
          makes[f.make] = makes[f.make] || {};
          if (mk === '*') return;
          var r = makes[f.make][mk];
          if (!r) r = makes[f.make][mk] = { name: f.model, from: f.from, to: f.to };
          r.from = Math.min(r.from, f.from); r.to = Math.max(r.to, f.to);
          var vk = f.make + '|' + mk + '|' + f.model;
          votes[vk] = (votes[vk] || 0) + 1;
          if (votes[vk] > (votes[f.make + '|' + mk + '|' + r.name] || 0)) r.name = f.model;
        });
      }, function () { done({ fits: fits, makes: makes }); });
    });
  }

  // unify models that only differ by case/spacing ("C-Max" vs "C-MAX")
  function modelKey(s) { return norm(s).replace(/[^a-z0-9]/g, ''); }

  // ---- registration lookup: map DVSA wording ("VAUXHALL", "TRANSIT CUSTOM 290 LIMITED") onto the finder's lists ----

  // makes: the finder's make names, e.g. ["Ford", "Vauxhall / Opel", "Mercedes-Benz"]
  function matchMake(raw, makes) {
    if (!raw) return null;
    var lm = leadingMake(String(raw).trim());
    if (lm && makes.indexOf(lm.make) > -1) return lm.make;
    var k = modelKey(raw);
    for (var i = 0; i < makes.length; i++) if (modelKey(makes[i]) === k) return makes[i];
    return null;
  }

  // models: the finder's { modelKey: { name } } for one make. Returns the best modelKey or null.
  function matchModel(make, raw, models) {
    if (!raw) return null;
    var text = norm(String(raw)).replace(/[^a-z0-9]+/g, ' ').trim();
    var compact = text.replace(/ /g, '');
    var guesses = [];
    // DVSA gives BMW and Mercedes model codes rather than series names: 320D -> 3 Series, C220 -> C-Class
    if (make === 'BMW') {
      var b = compact.match(/^(\d)(\d\d)/) || text.match(/^(\d) series/);
      if (b) guesses.push(b[1] + ' Series');
      var bx = compact.match(/^([xzm]\d)/);
      if (bx) guesses.push(bx[1].toUpperCase());
    }
    if (make === 'Mercedes-Benz') {
      var m = text.match(/^([a-z]{1,3}) ?\d{2,3}/);
      if (m) guesses.push(m[1].toUpperCase() + '-Class', m[1].toUpperCase()); // C220 -> C-Class; SLK200 -> SLK
    }
    var best = null, bestScore = 0;
    Object.keys(models).forEach(function (key) {
      var name = models[key].name, nk = modelKey(name);
      var words = norm(name).replace(/[^a-z0-9]+/g, ' ').trim().split(' ');
      var score = 0;
      guesses.forEach(function (g) { if (modelKey(g) === nk) score = 1000; });
      if (!score && nk && compact.indexOf(nk) === 0) score = 100 + nk.length;                       // "transitcustom290" starts with "transitcustom"
      if (!score && words.every(function (w) { return (' ' + text + ' ').indexOf(' ' + w + ' ') > -1; })) score = 50 + nk.length; // every word appears
      if (score > bestScore) { bestScore = score; best = key; }
    });
    return best;
  }

  return { build: build, buildAsync: buildAsync, parseProduct: parseProduct, modelKey: modelKey, norm: norm, lines: lines, matchMake: matchMake, matchModel: matchModel };
})();

/* ---------- Key Finder UI ---------- */
(function () {
  if (!window.customElements || customElements.get('key-finder')) return;

  var CACHE_KEY = 'kf-feed-v1';
  var CACHE_MS = 30 * 60 * 1000;       // re-read the catalogue every 30 minutes
  var VEHICLE_KEY = 'kf-vehicle';
  var CATS = [
    ['remote', 'Remote keys'],
    ['case', 'Key cases'],
    ['transponder', 'Transponders'],
    ['tool', 'Locksmith tools'],
    ['other', 'Other']
  ];

  function store(k, v) {
    try { if (v === undefined) return JSON.parse(localStorage.getItem(k)); if (v === null) localStorage.removeItem(k); else localStorage.setItem(k, JSON.stringify(v)); } catch (e) { return null; }
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function byName(a, b) { return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' }); }
  function category(p) {
    var ty = (p.ty || '').toLowerCase(), v = (p.v || '').toLowerCase(), t = (p.t || '').toLowerCase();
    if (ty.indexOf('lock pick') > -1 || /lishi|pick and decoder/.test(t)) return 'tool';
    if (ty.indexOf('key case') > -1 || v.indexOf('key case') > -1 || /\bcase\b|housing|shell/.test(t)) return 'case';
    if (ty === 'transponder' || /transponder chip|\bchip\b/.test(t)) return 'transponder';
    if (ty.indexOf('remote') > -1 || /remote|smart key|key card/.test(t)) return 'remote';
    return 'other';
  }
  function yrs(a, b) { return a === b ? String(a) : a + '–' + (b >= new Date().getFullYear() ? 'on' : b); }

  function loadFeed(url) {
    var cached = store(CACHE_KEY);
    if (cached && cached.url === url && Date.now() - cached.ts < CACHE_MS && cached.products && cached.products.length) {
      return Promise.resolve(cached.products);
    }
    var all = [];
    function page(n) {
      return fetch(url + '&page=' + n, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('feed ' + r.status); return r.text(); })
        .then(function (txt) {
          var j = JSON.parse(txt);
          all = all.concat(j.products || []);
          if (j.pages > n && n < 40) return page(n + 1);
          return all;
        });
    }
    return page(1).then(function (products) {
      store(CACHE_KEY, { url: url, ts: Date.now(), products: products });
      return products;
    });
  }

  class KeyFinder extends HTMLElement {}

  KeyFinder.prototype.connectedCallback = function () {
    if (this._init) return;
    this._init = true;
    var self = this;
    this.$ = function (s) { return self.querySelector(s); };
    this.form = this.$('.kf-form');
    this.selMake = this.$('select[name=make]');
    this.selModel = this.$('select[name=model]');
    this.selYear = this.$('select[name=year]');
    this.btn = this.$('.kf-form .kf-go'); // not the reg search button, which comes first
    this.filter = 'all';

    this.classList.add('is-loading');

    // Loading and parsing the catalogue is the heaviest script on the page, so wait until the
    // visitor starts using the page (or the page has settled) instead of doing it during load.
    // The results page, or a link with ?make=, needs the data straight away.
    var started = false;
    var start = function () {
      if (started) return;
      started = true;
      WAKE.forEach(function (ev) { window.removeEventListener(ev, start, true); });
      self.removeEventListener('pointerenter', start);
      self.removeEventListener('focusin', start);
      self.load();
    };
    var WAKE = ['scroll', 'pointerdown', 'pointermove', 'keydown', 'touchstart'];
    if (this.dataset.results !== 'page' || /[?&]make=/.test(location.search)) {
      start();
    } else {
      WAKE.forEach(function (ev) { window.addEventListener(ev, start, { capture: true, passive: true, once: true }); });
      this.addEventListener('pointerenter', start);
      this.addEventListener('focusin', start);
      var later = function () { setTimeout(function () { (window.requestIdleCallback || setTimeout)(start, { timeout: 2000 }); }, 5000); };
      if (document.readyState === 'complete') later(); else window.addEventListener('load', later, { once: true });
    }

    this._start = start;
    this._ready = new Promise(function (resolve) { self._resolveReady = resolve; });

    this.selMake.addEventListener('change', function () { self.onMake(); });
    this.selModel.addEventListener('change', function () { self.onModel(); });
    this.selYear.addEventListener('change', function () { self.onYear(); });
    this.form.addEventListener('submit', function (e) { e.preventDefault(); self.submit(true); });

    var reg = this.$('[data-kf-reg]');
    if (reg && this.dataset.regEndpoint) {
      reg.addEventListener('submit', function (e) { e.preventDefault(); self.lookupReg(); });
      reg.addEventListener('focusin', start);
    }
  };

  // Registration search: ask our lookup service for make/model/year, then fill in the three boxes.
  KeyFinder.prototype.lookupReg = function () {
    var self = this;
    var input = this.$('[data-kf-reg] input'), msg = this.$('.kf-reg-msg'), btn = this.$('.kf-reg-go');
    var vrm = input.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
    var say = function (text, state) { msg.textContent = text; msg.setAttribute('data-state', state || ''); };
    var fallback = ' Please choose your vehicle below.';
    if (!/^[A-Z0-9]{2,8}$/.test(vrm)) { say('Please enter a UK registration, e.g. AB12 CDE.', 'error'); input.focus(); return; }

    btn.disabled = true;
    say('Checking ' + vrm + '…', 'busy');
    this._start();
    var lookup = fetch(this.dataset.regEndpoint + '?vrm=' + encodeURIComponent(vrm))
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { status: r.status, data: j }; }); });

    Promise.all([lookup, this._ready]).then(function (res) {
      var status = res[0].status, v = res[0].data;
      if (status === 404) return say("We couldn't find that registration." + fallback, 'error');
      if (status === 429) return say('Too many searches, please try again in a few minutes.' + fallback, 'error');
      if (status !== 200 || !v.make) return say("Reg search isn't available right now." + fallback, 'error');

      var make = CKS.matchMake(v.make, Object.keys(self.index.makes));
      if (!make) return say('That looks like a ' + [v.year, v.make, v.model].filter(Boolean).join(' ') + ". We don't list keys for it yet. Send us a photo of your key and we'll check for you.", 'error');
      var models = self.index.makes[make] || {};
      var mk = CKS.matchModel(make, v.model, models);
      var label = [v.year, make, mk ? models[mk].name : v.model].filter(Boolean).join(' ');

      self.set(make, mk, v.year);
      if (!mk) { say('Found a ' + label + '. Please choose your model below.', 'ok'); self.selModel.focus(); return; }
      if (!self.selYear.value) { say('Found a ' + label + '. Please choose your year below.', 'ok'); self.selYear.focus(); return; }
      say('Found a ' + label + '. Showing the keys that fit…', 'ok');
      self.submit(true);
    }).catch(function () {
      say("Reg search isn't available right now." + fallback, 'error');
    }).then(function () { btn.disabled = false; });
  };

  KeyFinder.prototype.load = function () {
    var self = this;
    loadFeed(this.dataset.feed).then(function (products) {
      self.products = products;
      CKS.buildAsync(products.map(function (p) {
        return { title: p.t, vendor: p.v, tags: p.tg || [], body_html: (p.d || []).join('<br>') };
      }), function (index) {
        self.index = index;
        self.classList.remove('is-loading');
        self.ready();
        if (self._resolveReady) self._resolveReady();
      });
    }).catch(function (e) {
      self.classList.remove('is-loading');
      self.selMake.innerHTML = '<option value="">Search unavailable – please refresh</option>';
      if (self._resolveReady) self._resolveReady();
      if (window.console) console.warn('Key finder:', e);
    });
  };

  KeyFinder.prototype.ready = function () {
    var self = this, makes = this.index.makes;
    var names = Object.keys(makes).filter(function (m) { return Object.keys(makes[m]).length; }).sort(byName);
    this.selMake.innerHTML = '<option value="">Select make</option>' + names.map(function (m) {
      return '<option value="' + esc(m) + '">' + esc(m) + '</option>';
    }).join('');
    this.selMake.disabled = false;

    // popular makes = most products listed
    var pop = this.$('.kf-popular');
    if (pop) {
      var count = {};
      var seen = {};
      this.index.fits.forEach(function (f) { var k = f[1] + '|' + f[0]; if (!seen[k]) { seen[k] = 1; count[f[1]] = (count[f[1]] || 0) + 1; } });
      var top = Object.keys(count).sort(function (a, b) { return count[b] - count[a]; }).slice(0, 6);
      pop.querySelector('.kf-chips').innerHTML = top.map(function (m) {
        return '<button type="button" class="kf-chip" data-make="' + esc(m) + '">' + esc(m) + '</button>';
      }).join('');
      pop.hidden = false;
      pop.addEventListener('click', function (e) {
        var b = e.target.closest('.kf-chip'); if (!b) return;
        self.set(b.dataset.make); self.selModel.focus();
      });
    }

    // saved vehicle chip
    this.saved = this.$('.kf-saved');
    if (this.saved) {
      this.saved.querySelector('.kf-saved-btn').addEventListener('click', function () {
        var v = store(VEHICLE_KEY); if (v) { self.set(v.make, v.model, v.year); self.submit(true); }
      });
      this.saved.querySelector('.kf-clear').addEventListener('click', function () {
        store(VEHICLE_KEY, null); self.renderSaved();
      });
    }

    // URL (?make=&model=&year=) wins, then the remembered vehicle
    var q = new URLSearchParams(location.search);
    if (q.get('make')) {
      this.set(q.get('make'), q.get('model'), q.get('year'));
      if (this.selYear.value) this.submit(false);
    } else {
      var v = store(VEHICLE_KEY);
      if (v) this.set(v.make, v.model, v.year);
    }
    this.renderSaved();
  };

  KeyFinder.prototype.renderSaved = function () {
    if (!this.saved) return;
    var v = store(VEHICLE_KEY);
    this.saved.hidden = !v;
    if (v) this.saved.querySelector('.kf-saved-btn').innerHTML =
      '<svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 17H3v-5l2-5h11l4 5h1v5h-2"/><circle cx="7.5" cy="17.5" r="2"/><circle cx="16.5" cy="17.5" r="2"/></svg>' +
      esc(v.year + ' ' + v.make + ' ' + v.modelName);
  };

  // select by names (tolerant of case), used by URL params, chips and saved vehicle
  KeyFinder.prototype.set = function (make, model, year) {
    var pick = function (sel, val) {
      if (!val) return false;
      var n = CKS.norm(String(val)), k = CKS.modelKey(String(val));
      for (var i = 0; i < sel.options.length; i++) {
        var o = sel.options[i];
        if (o.value && (CKS.norm(o.value) === n || o.value === k || CKS.norm(o.dataset.name || '') === n)) { sel.value = o.value; return true; }
      }
      return false;
    };
    if (!pick(this.selMake, make)) return;
    this.onMake();
    if (!pick(this.selModel, model)) return;
    this.onModel();
    if (pick(this.selYear, year)) this.onYear();
  };

  KeyFinder.prototype.mark = function () {
    var f = function (sel) { sel.closest('.kf-field').classList.toggle('is-done', !!sel.value); };
    f(this.selMake); f(this.selModel); f(this.selYear);
    this.btn.disabled = !this.selYear.value;
  };

  KeyFinder.prototype.onMake = function () {
    var models = this.index.makes[this.selMake.value] || {};
    var keys = Object.keys(models).sort(function (a, b) { return byName(models[a].name, models[b].name); });
    this.selModel.innerHTML = '<option value="">Select model</option>' + keys.map(function (k) {
      var m = models[k];
      return '<option value="' + esc(k) + '" data-name="' + esc(m.name) + '">' + esc(m.name) + '  (' + yrs(m.from, m.to) + ')</option>';
    }).join('');
    this.selModel.disabled = !keys.length;
    this.selYear.innerHTML = '<option value="">Select year</option>';
    this.selYear.disabled = true;
    this.mark();
  };

  KeyFinder.prototype.onModel = function () {
    var make = this.selMake.value, mk = this.selModel.value, years = {};
    this.index.fits.forEach(function (f) {
      if (f[1] === make && f[2] === mk) for (var y = f[3]; y <= f[4]; y++) years[y] = 1;
    });
    var list = Object.keys(years).map(Number).sort(function (a, b) { return b - a; });
    this.selYear.innerHTML = '<option value="">Select year</option>' + list.map(function (y) {
      return '<option value="' + y + '">' + y + '</option>';
    }).join('');
    this.selYear.disabled = !list.length;
    this.mark();
  };

  KeyFinder.prototype.onYear = function () { this.mark(); if (this.selYear.value) this.btn.focus({ preventScroll: true }); };

  KeyFinder.prototype.submit = function (userAction) {
    var make = this.selMake.value, mk = this.selModel.value, year = +this.selYear.value;
    if (!make || !mk || !year) return;
    var modelName = this.selModel.selectedOptions[0].dataset.name;
    store(VEHICLE_KEY, { make: make, model: mk, modelName: modelName, year: year });
    this.renderSaved();

    var params = '?make=' + encodeURIComponent(make) + '&model=' + encodeURIComponent(modelName) + '&year=' + year;
    if (this.dataset.results === 'page' && this.dataset.resultsUrl && location.pathname !== this.dataset.resultsUrl) {
      location.href = this.dataset.resultsUrl + params;
      return;
    }
    try { history.replaceState(null, '', location.pathname + params); } catch (e) {}

    var hits = {}, order = [];
    this.index.fits.forEach(function (f) {
      if (f[1] !== make || (f[2] !== mk && f[2] !== '*') || year < f[3] || year > f[4]) return;
      if (!hits[f[0]]) { hits[f[0]] = []; order.push(f[0]); }
      hits[f[0]].push(f);
    });
    this.vehicle = year + ' ' + make + ' ' + modelName;
    this.hits = hits;
    this.order = order;
    this.filter = 'all';
    this.renderResults();
    var box = document.querySelector('[data-kf-results-page]') || this.$('.kf-results');
    if (userAction && box.getBoundingClientRect().top > window.innerHeight * 0.6) box.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  KeyFinder.prototype.renderResults = function () {
    var self = this, P = this.products, box = this.$('.kf-results');
    var catRank = {}; CATS.forEach(function (c, i) { catRank[c[0]] = i; });
    var items = this.order.map(function (i) { return { i: i, p: P[i], cat: category(P[i]), f: self.hits[i] }; });
    items.sort(function (a, b) {
      return (catRank[a.cat] - catRank[b.cat]) || ((b.p.a ? 1 : 0) - (a.p.a ? 1 : 0)) || byName(a.p.t, b.p.t);
    });

    // A "kf-results" section on the page (search-page style grid with the theme's own cards) shows the
    // results instead: hand it the matching products, best match first, and keep our own list hidden.
    if (document.querySelector('[data-kf-results-page]')) {
      var catLabel = {}; CATS.forEach(function (c) { catLabel[c[0]] = c[1]; });
      var detail = {
        vehicle: this.vehicle,
        items: items.map(function (it) {
          var f = it.f[0];
          return {
            url: it.p.u, cat: it.cat, catName: catLabel[it.cat],
            fit: f[2] === '*' ? 'Fits all ' + f[1] + ' ' + yrs(f[3], f[4]) : 'Fits ' + f[5] + ' ' + yrs(f[3], f[4])
          };
        })
      };
      window.kfLastResults = detail;
      document.dispatchEvent(new CustomEvent('kf:results', { detail: detail }));
      box.hidden = true;
      return;
    }

    var counts = { all: items.length };
    items.forEach(function (it) { counts[it.cat] = (counts[it.cat] || 0) + 1; });
    var filters = [['all', 'All']].concat(CATS).filter(function (c) { return counts[c[0]]; });
    if (!counts[this.filter]) this.filter = 'all';
    var fbox = this.$('.kf-filters');
    fbox.innerHTML = filters.length > 2 ? filters.map(function (c) {
      return '<button type="button" role="tab" class="kf-filter" data-f="' + c[0] + '" aria-selected="' + (c[0] === self.filter) + '">' +
        esc(c[1]) + ' <span>' + counts[c[0]] + '</span></button>';
    }).join('') : '';
    fbox.onclick = function (e) {
      var b = e.target.closest('.kf-filter'); if (!b) return;
      self.filter = b.dataset.f; self.renderResults();
    };

    var shown = items.filter(function (it) { return self.filter === 'all' || it.cat === self.filter; });
    this.$('.kf-results-title').innerHTML = esc(this.vehicle) + ' <span class="kf-count">· ' + items.length + (items.length === 1 ? ' part' : ' parts') + '</span>';

    var tick = '<svg aria-hidden="true" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';
    var catName = {}; CATS.forEach(function (c) { catName[c[0]] = c[1].replace(/s$/, ''); });
    this.$('.kf-grid').innerHTML = shown.map(function (it) {
      var p = it.p, f = it.f[0];
      var fitLabel = f[2] === '*' ? 'Fits all ' + f[1] + ' ' + yrs(f[3], f[4]) : 'Fits ' + f[5] + ' ' + yrs(f[3], f[4]);
      return '<li><a class="kf-card" href="' + esc(p.u) + '">' +
        '<div class="kf-card-media">' +
          (p.i ? '<img src="' + esc(p.i) + '" alt="" loading="lazy" width="360" height="360">' : '') +
          '<span class="kf-tag">' + esc(catName[it.cat]) + '</span>' +
          (p.c ? '<span class="kf-tag is-sale">Sale</span>' : '') +
        '</div>' +
        '<div class="kf-card-body">' +
          '<p class="kf-card-title">' + esc(p.t.replace(/\.\s*$/, '')) + '</p>' +
          '<span class="kf-fit">' + tick + '<span>' + esc(fitLabel) + '</span></span>' +
          '<div class="kf-card-foot"><span class="kf-price">' + esc(p.p) + (p.c ? '<s>' + esc(p.c) + '</s>' : '') + '</span>' +
          '<span class="kf-stock' + (p.a ? '' : ' is-out') + '">' + (p.a ? 'In stock' : 'Sold out') + '</span></div>' +
        '</div></a></li>';
    }).join('');
    this.$('.kf-empty').hidden = items.length > 0;
    box.hidden = false;
  };

  customElements.define('key-finder', KeyFinder);
})();

